// src/patterns/TypeSystem.jsx
import React from "react";
import UnderlineSketch from "../components/UnderlineSketch";

// Headlines bleiben bewusst monospace – für Stil und Klarheit
export const Headline = ({ children }) => (
  <h1 className="text-2xl md:text-3xl font-bold tracking-tight font-mono">
    {children}
    <div className="mt-2">
     
    </div>
  </h1>
);

// Subline: lieber Sans-Serif für bessere Lesbarkeit bei Fließtext
export const Subline = ({ children }) => (
  <p className="text-xs text-gray-700 font-mono">{children}</p>
);

// BodyText: ebenfalls Sans für Lesefluss – aber du kannst bei Bedarf zwischen Varianten wechseln
export const BodyText = ({ children, mono = false }) => (
  <p className={`text-base leading-relaxed ${mono ? "font-mono text-black" : "font-sans text-gray-800"}`}>
    {children}
  </p>
);